import { HttpBackend, HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, TemplateRef } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import * as jwt_decode from 'jwt-decode';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
const { detect } = require('detect-browser');
const browser = detect();

export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}

@Component({
  templateUrl: './projectFromFormLink.component.html',
  styleUrls: ['./projectFromFormLink.component.scss']
})

export class ProjectFromFormLinkComponent implements OnInit {
  projectId: any;
  userID: any;
  eventLogMessage: any;
  ipAddress: any;
  device: any;
  browsername: any;
  responseHolder: any;
  projectGroups: any[];
  SendButtonDisabled: boolean;
  organizationId: any;
  databaseId: any;
  formID: any;
  token: any;
  params: string;
  groupRelationParticipantMappingID: any;
  type: any;
  groupID: any;
  relationColour: any;
  relationID: any;
  showAddButton: boolean;
  contactemail: string = "";
  contactId: number = 0;
  transRoleList: any[];
  contactsList: any[];
  Roles: any[];
  peoples: any[];
  selectedsharedAccessRole: any[];
  showContactRoleAddButton: boolean;
  dialogRef: any;
  participantEmail: string;
  isSharedAccessRolePopup: boolean = false;
  isRolePopup: boolean = false;
  OfficeIDList: any = [];
  myOfficeID: any;
  objectList: any = [];
  TaskID: any = 0;
  participantMessageInfo: string = null;
  toogleInformation = true;
  Selected3cType: any = 0;
  Name: any = '';
  Email: any = '';
  Phone: any = '';
  isEmailVerified: boolean = false;
  isSenDProjectDirectly: boolean = false;
  portalEmail: any="";
  accessFrom:string="";
  accessEmail:string="";

  constructor(private http: HttpClient, private httpbackend: HttpBackend, private dialog: MatDialog, private router: Router,
    private route: ActivatedRoute, private formsService: FormsService,
    private loaderService: LoaderService, private toastr: ToastrService,
    private cdr: ChangeDetectorRef, private reusableClass: ReusableClasses, private statusConstant: StatusConstant, private encryptionAlgo: EncryptionService,) {
    var skipInterceptor = new HttpClient(httpbackend);
    skipInterceptor.get<{ ip: string }>('https://jsonip.com').subscribe(data => {
      this.ipAddress = data.ip
    });

    this.stateCtrl.setValue(this.stateCtrlValue);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''), map((state) => (state ? this._filterStates(state) : this.states.slice()))
    );
  }

  states = this.objectList;

  private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();
    return this.states.filter((state) => state.name.toLowerCase().indexOf(filterValue) === 0);
  }


  ngOnInit(): void {
    if (browser) {
      this.browsername = browser.name;
      this.device = browser.os;
    }
    this.getQueryParameter();
  }

  getShortName(fullName) {
    return fullName.split(' ').map(n => n[0]).join('');
  }

  getQueryParameter() {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      this.portalEmail = params['email'];
      this.accessFrom = params['access'];
      this.accessEmail= params['email'];
      this.params = decodeURIComponent(this.token);
      const tokenm = this.encryptionAlgo.get(this.reusableClass.encryptionKey, this.params);
      let decryptedToken = JSON.parse(tokenm)
      this.formID = decryptedToken.FormID;
      this.organizationId = decryptedToken.OrganizationID;
      this.databaseId =decryptedToken.DatabaseID == undefined ? 0 : decryptedToken.DatabaseID;
      this.userID = decryptedToken.UserID;
      this.myOfficeID = decryptedToken.OfficeID;
      this.Selected3cType = decryptedToken.Selected3cType;
      this.TaskID = decryptedToken.taskID == undefined ? 0 : decryptedToken.taskID;
    });
  }

  getEmailVerified() {
    let emailVerified: boolean;
    const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    emailVerified = regexp.test(this.Email);
    this.isEmailVerified = emailVerified;
  }

  closeEmailPopup() {
    this.dialog.closeAll();
    this.isEmailVerified = false;
    this.Name = '';
    this.Phone = '';
    this.Email = '';
  }

  ifSaveButtonDisabled() {
     if (this.Selected3cType == 1 && (this.isEmailVerified == false || this.Name == undefined || this.Name.trim() == '')) {
   // if (this.Selected3cType == 1 && (this.isEmailVerified == false || this.Name == undefined || this.Name.trim() == '' || this.Phone == undefined || this.Phone.trim() == '')) {
      return true;
    }
    else {
      return false;
    }
  }

  IscreateProject(templateRef: TemplateRef<any>, templateRefDetails: TemplateRef<any>) {
    // if(this.accessFrom =="portal"){
    //   return;
    // }
    if (this.Selected3cType == 1 && (this.isEmailVerified == false || this.Name == undefined || this.Phone == undefined || this.Name.trim() == '')) {
      this.dialog.open(templateRefDetails, {
        panelClass: 'signatureModal',
      });
    }
    else {
      this.dialog.closeAll();
      this.CreateProjectFromFormLink(templateRef);
    }
  }

  CreateProjectFromFormLink(templateRef: TemplateRef<any>) {
    this.projectGroups = [];
    var ReqModel = {
      formID: this.formID,
      userID: this.userID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      TaskID: this.TaskID,
      Name: this.Name,
      Email: this.Email,
      Phone: this.Phone,
      Selected3cType: this.Selected3cType,
      UserEmailForCode: (this.portalEmail==null || this.portalEmail)==undefined ?"":this.portalEmail
    }
    this.loaderService.show();
    this.formsService.CreateProjectFromFormLink(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;

        let partcipantCheckList = [];
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.projectGroups = this.responseHolder.data;
          if (this.projectGroups.filter(e => e.groupName !== "Send Final Copy" && e.groupName !== "View Only" ).length > 0) {
            this.participantMessageInfo = this.projectGroups[0].participantMessageInfo;
            for (var i = 0, lennew = this.projectGroups.filter(e => e.groupName !== "Send Final Copy" && e.groupName !== "View Only" ).length; i < lennew; ++i) {
              var projGrpRelationParticipantList = [];
             // this.projectGroups[i].projGrpRelationParticipantList = this.projectGroups[i].projGrpRelationParticipantList.filter(m => m.isApprover != true);
              projGrpRelationParticipantList = this.projectGroups[i].projGrpRelationParticipantList;
              partcipantCheckList = partcipantCheckList.concat(projGrpRelationParticipantList);
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  // var matchRole=[];
                  // matchRole= this.MatchingRole.filter(m=>m.roleName==projGrpRelationParticipantList[i1].relationName);  
                  // if(matchRole.length > 0){
                  //   this.projectGroups[i].projGrpRelationParticipantList[i1].selectedContactFieldEmailID=matchRole;
                  // }else{
                  //   this.projectGroups[i].projGrpRelationParticipantList[i1].selectedContactFieldEmailID=null;
                  // }              
                }
              }
              else {
              }
            }
          }


          if (this.projectGroups.length > 0) {
            this.projectId = this.projectGroups[0].projectID;
          }

          var data = [];
          data = this.projectGroups

          if (data.length > 0) {
            this.eventLogMessage = "Sent for signature to ";
            var checkGroup = this.projectGroups.filter(m => m.groupType == 1);
            if (checkGroup.length > 0) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = checkGroup[0].projGrpRelationParticipantList;
              for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
                var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
                var email = "";
                if (checkEmailAnonmous != "") {
                  email = checkEmailAnonmous;
                  this.eventLogMessage += '(' + email + '), ';
                }
                if (checkEmail != "") {
                  email = checkEmail;
                  this.eventLogMessage += '(' + email + '), ';
                }
              }
            }

            var checkViewOnly = this.projectGroups.filter(m => m.groupType == 3);
            if (checkViewOnly.length > 0) {
              for (var i = 0, len4 = checkViewOnly.length; i < len4; ++i) {
                var projGrpRelationParticipantList = [];
                projGrpRelationParticipantList = checkViewOnly[i].projGrpRelationParticipantList;
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  var checkEmailAnonmous = projGrpRelationParticipantList[i1].contactEmail;
                  var checkEmail = projGrpRelationParticipantList[i1].participantEmail;
                  var email = "";
                  if (checkEmailAnonmous != "") {
                    email = checkEmailAnonmous;
                    this.eventLogMessage += '(' + email + '), ';
                  }
                  if (checkEmail != "") {
                    email = checkEmail;
                    this.eventLogMessage += '(' + email + '), ';
                  }
                }
              }
            }
          }

          this.eventLogMessage = this.eventLogMessage.replace(/,\s*$/, "");

          if (this.Email != undefined && this.Email != '' && this.Email != null) {
            if (partcipantCheckList.length == 1) {
             // this.ProjectSend();
             this.dialog.open(templateRef, {
              panelClass: 'signatureModal',
            });
            }
            else if (partcipantCheckList.length > 1) {
              // let participantWithOutEmail = partcipantCheckList.find(m => m.contactEmail == '' && m.participantEmail == "" && m.roleID == "0")
              // if (participantWithOutEmail == undefined) {
              //   this.ProjectSend();
              // }
              // else {
              //   this.dialog.open(templateRef, {
              //     panelClass: 'signatureModal',
              //   });
              // }

              this.dialog.open(templateRef, {
                panelClass: 'signatureModal',
              });
            }
            else {
              this.dialog.open(templateRef, {
                panelClass: 'signatureModal',
              });
            }
          }
          else if (partcipantCheckList.length > 1) {
            let participantWithOutEmail = partcipantCheckList.find(m => m.contactEmail == '' && m.participantEmail == "" && m.roleID == "0")
            if (participantWithOutEmail == undefined) {
             // this.ProjectSend();
             this.dialog.open(templateRef, {
              panelClass: 'signatureModal',
            });
            }
            else {
              this.dialog.open(templateRef, {
                panelClass: 'signatureModal',
              });
            }
          }
          else {
            this.dialog.open(templateRef, {
              panelClass: 'signatureModal',
            });
          }
          var check = []
          check = this.responseHolder.data.filter(x => x.groupType === 1);
          if (check.length > 0) {
            for (var i = 0, len = check.length; i < len; ++i) {
              var projGrpRelationParticipantList = [];
              projGrpRelationParticipantList = check[i].projGrpRelationParticipantList;
              if (projGrpRelationParticipantList.length > 0) {
                for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                  if (projGrpRelationParticipantList[i1].contactEmail == "" && projGrpRelationParticipantList[i1].participantEmail == "" && projGrpRelationParticipantList[i1].roleID == "0") {
                    this.SendButtonDisabled = false;
                    return;
                  } else {
                    this.SendButtonDisabled = true;
                    // return;
                  }
                }
              }
              else {
              }
            }
          }
        } else {
          this.loaderService.hide();
          this.projectGroups = [];
          this.dialog.closeAll();
        }
      } else {
        this.loaderService.hide();
        this.projectGroups = [];
        this.dialog.closeAll();
      }
    });

  }

  close() {
    this.dialog.closeAll();
  }

  closeAssign() {
    if (this.dialogRef != undefined) {
      this.dialogRef.close();
      this.peoples = [];
      this.SendButtonDisabled = false;
      this.showAddButton = false;
    }
  }

  CheckENableDoneButtton() {
    if (this.contactemail !== '') {
      this.showAddButton = true;
      this.SendButtonDisabled = true;
    } else {
      this.SendButtonDisabled = false;
      this.showAddButton = false;
    }
  }

  addUpdateParticipants() {
    var name = "";
    if (this.peoples.length > 0) {
      if (this.peoples[0].email != "" || this.peoples[0].email != null || this.peoples[0].email != undefined) {
        this.contactemail = this.peoples[0].email;
        name = this.peoples[0].name;
        this.contactId = this.peoples[0].contactID;
      }
    }
    if (this.peoples.length == 0) {
      this.contactId = 0;
    }
    if (this.contactemail != "" || this.contactemail != null || this.contactemail != undefined) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var check = re.test(String(this.contactemail).toLowerCase());
      if (check == true) {
      } else {
        this.toastr.warning('Please provide valid email.', '', {
          timeOut: 3000,
        });
        return;
      }
    }

    this.closeAssign();
    this.loaderService.show();
    this.projectGroups.forEach(e => {
      if (e.projGrpRelationParticipantList.length > 0) {
        e.projGrpRelationParticipantList.forEach(ee => {
          if (ee.groupRelationParticipantMappingID == this.groupRelationParticipantMappingID) {
            ee.contactEmail = this.contactemail;
            ee.participantName = name;
          }
        });
      }
    });
    this.SendButtonDisabled = true;
    var ReqModel = {
      groupRelationParticipantMappingID: this.groupRelationParticipantMappingID,
      contactEmail: this.contactemail,
      contactID: this.contactId,
      officeID: this.myOfficeID,
      userID: this.userID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      typeOfParticipant:this.typeOfParticipant
    }
    // return;
    this.formsService.UpdateParticipantDeatil(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.peoples = [];
          this.showAddButton = false;
          this.loaderService.hide();
        } else {
          this.peoples = [];
          this.showAddButton = false;
          this.loaderService.hide();
        }
      } else {
        this.peoples = [];
        this.showAddButton = false;
        // this.SendButtonDisabled=false;
        this.loaderService.hide();
      }
    });
  }


  assignUser(templateRef: TemplateRef<any>, isShare: boolean, isRole: boolean, contact: any, p, p1) {
    this.type = p1.type;
    this.projectId = p1.projectID;
    this.groupRelationParticipantMappingID = p.groupRelationParticipantMappingID;
    this.groupID = p.groupID;
    this.relationColour = p.relationColour;
    this.relationID = p.relationID;
    this.showAddButton = false;
    this.contactemail = p.contactEmail;
    this.transRoleList = [];
    this.contactsList = [];
    this.Roles = [];
    this.peoples = [];
    this.selectedsharedAccessRole = [];
    this.participantEmail = "";
    this.showContactRoleAddButton = false;
    this.dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
  }

  typeOfParticipant:number=0;

  assignUserNew(templateRef: TemplateRef<any>, isShare: boolean, isRole: boolean, contact: any, p, p1) {
    // For Contact //
   // if(p.typeOfParticipant==2){
      this.getTypeOfParticipants();
   // }
    this.typeOfParticipant=p.typeOfParticipant;
       // Email =0
      if(this.typeOfParticipant==0){
        this.textNameShow="Email";
      }
       // Contact =2
      if(this.typeOfParticipant==2){
        this.textNameShow="Contact";
      }
    this.type = p1.type;
    this.projectId = p1.projectID;
    this.groupRelationParticipantMappingID = p.groupRelationParticipantMappingID;
    this.groupID = p.groupID;
    this.relationColour = p.relationColour;
    this.relationID = p.relationID;
    this.showAddButton = false;
    this.contactemail = p.contactEmail;
    this.transRoleList = [];
    this.contactsList = [];
    this.Roles = [];
    this.peoples = [];
    this.selectedsharedAccessRole = [];
    this.participantEmail = "";
    this.emailAssigned="";
    this.showContactRoleAddButton = false;
    this.dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
  }

 

  ProjectSend() {
// Utility function to check if a value is empty, undefined, or null
const isEmptyOrNull = (value) => value === "" || value === undefined || value === null;

// Function to check if a participant has an empty email
const isEmptyEmail = (ee) => isEmptyOrNull(ee.contactEmail);

// Check if all project groups have no participants with empty email
const allParticipantsEmpty = this.projectGroups
  .filter(e => e.groupName !== "Send Final Copy" && e.groupName !== "View Only" && e.projGrpRelationParticipantList.length > 0)
  .every(e => e.projGrpRelationParticipantList.every(isEmptyEmail));

if (allParticipantsEmpty ) {
  this.toastr.warning('To send the project, ensure that at least one participant has a valid email address.', '', {
    timeOut: 3000,
  });
  // All participants have no email
  return false; 
}
    this.dialog.closeAll();
    var ReqModel = {
      folderId: 1,
      projectId: this.projectId,
      projectName: "",
      userID: this.userID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      type: 1,  // 1 Form Send , 2 Sand an Save , 3 Save Template Only 
      fileManagerFolderId: 0
    }
    this.loaderService.show()
    this.formsService.AddProjectInfoAsTemplete(ReqModel).subscribe((response) => {
      if (response != undefined) {
        if (response.status == this.statusConstant.statusSuccess && response.data != null) {
          this.loaderService.hide();
          this.AddProjectEventLog();
          this.toastr.success('Form has sent successfully to participants.', '', {
            timeOut: 3000,
          });
          this.router.navigate(['/request/thanksExternalProject'], { state: { isSent: true } });
        } else {
          this.loaderService.hide();
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  // To Add Project EventLog //
  async AddProjectEventLog() {
    try {
      var ReqModel = {
        projectID: this.projectId,
        ipAddress: this.ipAddress,
        message: this.eventLogMessage,
        eventType: 1, //Sent=1, View=2, Sign=3, Complete=4, Decline=5, Assign=6
        device: this.device,
        browser: this.browsername,
        userID: this.userID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
      }
      const result = await this.formsService.AddProjectEventLog(ReqModel).toPromise();
      this.responseHolder = result;
      if (this.responseHolder.status === this.statusConstant.statusSuccess) {
      } else {
        this.loaderService.hide();
      }
    } catch (e) {
      Observable.throw(e);
    }
  }

  timeout = null;
  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  roleInputCurrentvalue: any;
  stateCtrSendlValue: any;
  stateCtrlValue: string;

  searchUser(val) {
    this.contactsList = [];
    if (val != '') {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.getContactListCoreImplementation(val)
      }, 500);
    } else {
      this.contactsList = [];
    }
  }

  getContactListCoreImplementation(searchValue: any) {
    var ReqModel = {
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.userID,
      searchValue: searchValue,
      PageSize: 0,
       officeID:this.myOfficeID,
    }
    this.formsService.GetContactListCoreImplementation(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.peoples = [];
          this.contactsList = response.data.contactListModel;
          this.contactsList.forEach(e => {
            e.shortName = e.name.match(/\b(\w)/g).join('');
          });

          const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          var check = re.test(String(searchValue).toLowerCase());

          if (check == true) {
            var ReqModels = {
              contactID: 0,
              email: searchValue,
              img: "",
              name: "",
              shortName: ""
            }
            this.contactemail = searchValue;
            this.showAddButton = true;
            this.SendButtonDisabled = true;
          }
          if (check == false) {
            this.showAddButton = false;
            this.SendButtonDisabled = false;
          }
        } else {
          this.contactsList = [];
        }
      }
    }

    )
  }

  contactSelected(contactSelected: any) {
    this.peoples = [];
    let user = this.peoples.find(m => m.contactID == contactSelected.contactID);
    if (user == undefined || user == '' || user == null) {
      if (contactSelected.contactID == 0) {
        return;
      }
      if (contactSelected.email == "" || contactSelected.email == null || contactSelected.email == undefined) {
        this.toastr.warning('Selected contact is not associated with email.', '', {
          timeOut: 3000,
        });
        return;
      }
      var ReqModel = {
        contactID: contactSelected.contactID,
        email: contactSelected.email,
        name: contactSelected.name,
        img: contactSelected.imageUrl,
        shortName: contactSelected.shortName,
      }
      this.peoples.unshift(ReqModel);
      this.stateCtrl.reset();
      if (this.peoples.length > 0) {
        this.showAddButton = true;
      } else {
        this.showAddButton = false;
      }
    }
  }

  emailAssigned: string = '';

  emailCheck(searchValue: any) {
    if (searchValue.toLowerCase() == searchValue.toLowerCase().match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')) {
       this.emailAssigned = searchValue;
       this.contactemail = searchValue;
       this.showAddButton = true;
       this.SendButtonDisabled = true;
    } else {
      this.showAddButton = false;
      this.SendButtonDisabled = false;
    }
  }


  // Remove Relation 
  RemoveRelation(group) {
    const message = `Are you sure you want to delete this participant?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          this.loaderService.show();
          if (group !== undefined) {
            this.projectGroups.forEach(e => {
              if (e.projGrpRelationParticipantList.length > 0) {
                e.projGrpRelationParticipantList.forEach(ee => {
                  if (ee.groupRelationParticipantMappingID == group.groupRelationParticipantMappingID) {
                    ee.contactEmail = "";
                    ee.participantName = "";
                  }
                });
              }
            });
          }

          if (this.projectGroups.length > 0) {
            var check = []
            check = this.projectGroups.filter(x => x.groupType === 1);
            if (check.length > 0) {
              for (var i = 0, len = check.length; i < len; ++i) {
                var projGrpRelationParticipantList = [];
                projGrpRelationParticipantList = check[i].projGrpRelationParticipantList;
                if (projGrpRelationParticipantList.length > 0) {
                  for (var i1 = 0, len1 = projGrpRelationParticipantList.length; i1 < len1; ++i1) {
                    if (projGrpRelationParticipantList[i1].contactEmail == "" && projGrpRelationParticipantList[i1].participantEmail == "") {
                      this.SendButtonDisabled = false;
                      this.loaderService.hide();
                      return;
                    } else {
                      this.SendButtonDisabled = true;
                      this.loaderService.hide();
                      // return;
                    }
                  }
                }
                else {
                }
              }
            }
          }
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

    getToogleInformation() {
      this.toogleInformation = !this.toogleInformation;
    }

    typeofParticipantList:any=[]=[];
    textNameShow:string="Contact";

    getTypeOfParticipants() {
    var objReqModel={
      userID: this.userID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      officeID:this.myOfficeID,
    }
    this.formsService.getTypeOfParticipant(objReqModel).subscribe(response => {
      if (response !== undefined) {       
        this.responseHolder = response;
        if (this.responseHolder.status === this.statusConstant.statusSuccess) {
          this.typeofParticipantList= this.responseHolder.data;
          if(this.typeofParticipantList.length>0){
            // Filter email and Contact //
            this.typeofParticipantList = this.typeofParticipantList.filter(x=>x.value==0 || x.value==2)
            this.typeofParticipantList.map((res) => {
              if (res.value==0) {
                res.icon="email";
              }
              if (res.value==1) {
                res.icon="app_registration";
              }
              if (res.value==2) {
                res.icon="contact_mail";
              }
              if (res.value==3) {
                res.icon="business";
              }
              if (res.value==4) {
                res.icon="person";
              }
              if (res.value==5) {
                res.icon="work";
              }
            });
          }          
        } else {
          this.typeofParticipantList=[];
        }
      } else {
        this.typeofParticipantList=[];      
      }
    });
    }

    onSelectParticpant(typeOfParticipant) {
     this.showAddButton = false;
     this.emailAssigned="";
     this.typeOfParticipant = typeOfParticipant.value;
       // Email =0
      if(this.typeOfParticipant==0){
        this.textNameShow="Email";
      }
       // Contact =2
      if(this.typeOfParticipant==2){
        this.textNameShow="Contact";
      }
   }

}
